module.exports = __webpack_public_path__ + "img/title-1.0f63393f.png";